import React, { useContext, useEffect, useState } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { Separator } from '../../../components/Separator'
import { InitialInputVoiceSearch } from '../../../components/VoiceSearch/InitialInput/InitialInput'
import { FreshWaterContext } from '../../../context/FreshWater/FreshWaterContext'
import { UvFilter } from '../../../context/FreshWater/types'
import { corporateColor } from '../../../theme/colors'
import { InfoState } from '..'
import { ListItem } from './ListItem'
import { useTranslation } from 'react-i18next'
import { Items } from '../../../navigator/types'

interface Props {
  roomId: number
  getValues: (value: InfoState) => void
  initValues?: Items[]
}

export const UvFilterComponent = ({ roomId, getValues, initValues }: Props) => {
  const { t } = useTranslation()
  const { uvStates, uvFilters } = useContext(FreshWaterContext)
  const [pondsByRoom, setPondsByRooms] = useState<UvFilter[]>(() => uvFilters[roomId] ?? [])
  const [search, setSearch] = useState('')
  const [filteredData, setFilteredData] = useState<UvFilter[]>([])
  const getSearchValue = (value: string) => setSearch(value)

  useEffect(() => {
    setFilteredData(
      pondsByRoom.filter((pond) => pond.name.toLowerCase().includes(search.toLowerCase())),
    )
  }, [search, pondsByRoom])

  useEffect(() => {
    setPondsByRooms(() => uvFilters[roomId] ?? [])
  }, [roomId])

  return (
    <View style={{ flexGrow: 10 }}>
      <InitialInputVoiceSearch
        placeholder='Búsqueda de filtros uv'
        getSearchValue={getSearchValue}
        hasInput
      />

      <View style={{ flexDirection: 'row', alignItems: 'center', padding: 10 }}>
        <View style={{ flex: 0.9 }}>
          <Text style={styles.headerText}>{t('FILTRO UV')}</Text>
        </View>

        <View style={{ flex: 1 }}>
          <Text style={styles.headerText}>{t('NUEVO ESTADO')}</Text>
        </View>
      </View>

      <Separator />
      {filteredData.map((item, index) => (
        <ListItem
          item={item}
          isLastItem={index + 1 === filteredData.length}
          key={item.filterId}
          options={uvStates
            .map((option) => ({ id: option.id, name: t(option.name) }))
            .filter((item) => item.id !== 0)}
          onChange={getValues}
          defaultOptions={initValues
            ?.map((item) => ({
              id: item.stateId,
              name: t(item.stateName),
              levelThreeId: item.levelThreeId,
            }))
            .find((value) => value.levelThreeId === item.filterId)}
        />
      ))}
    </View>
  )
}

const styles = StyleSheet.create({
  headerText: {
    color: corporateColor,
    fontWeight: 'bold',
  },
})
